import { CarekartePassRole } from '../constants/GlobalConstants.config';

export enum Role {
  rolePublic = 'ROLE-PUBLIC',
  roleCCJAdmin = 'ROLE-CCJ-ADMIN',
  Live = 'LIVE',
  Control = 'CONTROL',
  Relative = 'RELATIVE',
  CCJAdmin = 'CCJ-ADMIN',
  CarekartePass = 'CAREKARTE-PASS',
}

export const RoleByKey = {
  CONTROL: [CarekartePassRole.STAFF, CarekartePassRole.SYSTEM_ADMIN],
  RELATIVE: [CarekartePassRole.RELATIVE],
  LIVE: [CarekartePassRole.PARTICIPANT],
};

export enum ControllerRole {
  DAI = 'dai',
  RELATIVE = 'relative',
  MESSAGE_FROM_RELATIVE = 'message-from-relative',
  CALL = 'stream-admin',
}

export enum ActionRole {
  VIEW = 'view',
  ADD = 'add',
  CALL_ACTION = 'call',
}

export enum PermissionKey {
  DAI_RELATED = 'DAI_RELATED',
  MESSAGE = 'MESSAGE',
  VIDEO_CALL = 'VIDEO_CALL',
  RECORD_SUMMARY = 'RECORD_SUMMARY',
  RECORD_LIST = 'RECORD_LIST',
  RECORD_GRAPH = 'RECORD_GRAPH',
  ALL_MESSAGE = 'ALL_MESSAGE',
  NOTIFICATION = 'NOTIFICATION',
  APPLY = 'APPLY',
  DISPLAY_SETTINGS = 'DISPLAY_SETTINGS',
  LIVE_SETTINGS = 'LIVE_SETTINGS',
  STAFF_MANAGEMENT = 'STAFF_MANAGEMENT',
  HELP = 'HELP',
  ACCOUNT = 'ACCOUNT',
  COMPANY_ANNOUNCEMENT = 'COMPANY_ANNOUNCEMENT',
  RP_COMPANY_ANNOUNCEMENT = 'RP_COMPANY_ANNOUNCEMENT',
  RP_RECORD_LIST = 'RP_RECORD_LIST',
  RP_RECORD_GRAPH = 'RP_RECORD_GRAPH',
  RP_VIDEO_CALL = 'RP_VIDEO_CALL',
  RP_HELP = 'RP_HELP',
  RP_ACCOUNT = 'RP_ACCOUNT',
  MASS_RELEASE_QR = 'MASS_RELEASE_QR',
  CONFIRM_AND_CONSENT_PLAN = 'CONFIRM_AND_CONSENT_PLAN',
  RP_PLANNING = 'RP_PLANNING',
  RP_IMAGE_DOWNLOAD = 'RP_IMAGE_DOWNLOAD',
  CONSENTER_SETTINGS = 'CONSENTER_SETTINGS',
  USER_PUBLISH_SETTINGS = 'USER_PUBLISH_SETTINGS',
  RECORD_PREVIEW = 'RECORD_PREVIEW',
}
